<template>
  <div :class="classes" :style="stylees">
    <router-view v-if="key.indexOf('/app-login') === -1"></router-view>
    <!-- 加载错误子应用页面 -->
    <m-error-App v-show="errorApp"/>
    <!-- 加载成功子应用页面 -->
    <div ref="animateApp" v-show="!errorApp" v-html="appContent"></div>
  </div>
</template>
<script>
  import singleSpa from '@/module/singleSpa'
  import Ps from '@/module/ps'
  import mErrorApp from './errorApp'

  const prefixCls = 'h-app-main-model'
  const ignorePadding = [ '/home', ...Ps.ignoreBackage ]

  export default {
    name: 'app-main',
    data () {
      return {}
    },
    mixins: [ singleSpa ],
    props: {},
    methods: {},
    watch: {},
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      key () {
        const { fullPath, meta: { animation = true } } = this.$route
        return animation ? fullPath : ''
      },
      stylees () {
        return {
          background: ignorePadding.includes(this.$route.path) ? 'transparent !important' : ''
        }
      },
      classes () {
        return [
          `${prefixCls}`,
          {
            [`${prefixCls}-no-pad`]: ignorePadding.includes(this.$route.path)
          }
        ]
      }
    },
    components: { mErrorApp }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "h-app-main-model";
  .#{$-prefix-cls} {
    margin:20px 20px 0px 20px;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    min-height: calc(100vh - 190px);
    box-shadow: 0px 0px 5px 0px #F1F8FF;
    &-no-pad {
      padding: 0px;
      background: none;
      border-radius: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/appMain.vue